import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { WaiterService } from '../_service/waiter.service';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PusherService } from '../_service/pusher.service';

@Component({
  selector: 'app-created-orders',
  standalone: true,
  imports: [RouterModule, CommonModule, ReactiveFormsModule],
  templateUrl: './created-orders.component.html',
  styleUrl: './created-orders.component.scss'
})
export class CreatedOrdersComponent implements OnInit, OnDestroy {
  minutes = 0
  id: string | null;
  orderDetails: any;
  activeWaiters: any[] = [];
  isTransferLoading = false;
  isLoading = true;
  isRefreshing = false;
  isProcessingPayment = false;
  isMarkingDelivered = false;
  isCancellingItem = false;
  transferForm = new FormGroup({
    waiter_id: new FormControl('', [Validators.required]),
    notes: new FormControl('', [Validators.required])
  });
  selectedAccount: any;
  @ViewChild('accountDetailsModal') accountDetailsModal: any;
  private subscription: Subscription = new Subscription();

  constructor(
    private modal: NgbModal,
    private route: ActivatedRoute,
    private service: WaiterService,
    private router: Router,
    private pusherService: PusherService
  ) {
    this.id = route.snapshot.paramMap.get('id')
  }
  ngOnInit(): void {
    this.getOrderDetails();
    this.loadActiveWaiters();

    // Subscribe to partial payment events
    this.subscription.add(
      this.pusherService.partialPayment$.subscribe(uid => {
        // Only refresh if this is the current order
        // alert(uid)
        if (uid == this.id) {
          this.getOrderDetails();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getOrderDetails() {
    this.service.viewOrder(this.id).subscribe({
      next: (res) => {
        this.orderDetails = res
      },
      complete: () => {
        this.isLoading = false;
        this.isRefreshing = false;
      }
    })
  }

  refreshOrder() {
    this.isRefreshing = true;
    this.getOrderDetails();
  }
  loadActiveWaiters() {
    this.service.getActiveWaiters().subscribe({
      next: (res: any) => {
        this.activeWaiters = res.data;
      },
      error: (err) => {
        Swal.fire({
          title: 'Error',
          text: err.error.message || 'Failed to load waiters',
          icon: 'error'
        });
      }
    });
  }
  openTransferModal(content: any) {
    this.transferForm.reset();
    this.modal.open(content, { centered: true });
  }

  transferOrder() {
    if (this.transferForm.valid) {
      this.isTransferLoading = true;

      const data = {
        waiter_id: this.transferForm.value.waiter_id,
        orders: [{ id: this.id }],
        notes: this.transferForm.value.notes
      };

      this.service.transferOrder(data).subscribe({
        next: (res: any) => {
          this.modal.dismissAll();
          Swal.fire({
            title: 'Success',
            text: 'Order transferred successfully',
            icon: 'success'
          }).then(() => {
            this.router.navigateByUrl('/');
          });
        },
        error: (err) => {
          Swal.fire({
            title: 'Error',
            text: err.error.message || 'Failed to transfer order',
            icon: 'error'
          });
          this.isTransferLoading = false;
        },
        complete: () => {
          this.isTransferLoading = false;
        }
      });
    }
  }

  // Modify your existing button click handler
  transferButtonClick(content: any) {
    this.openTransferModal(content);
  }
  showScroll: boolean = false;

  onCardScroll(card: HTMLElement) {
    // Show the button when the user scrolls down 100px or more within the card
    this.showScroll = card.scrollTop > 100;
  }

  // Scroll to the top of the card when the button is clicked
  scrollToTop(card: HTMLElement) {
    card.scrollTo({ top: 0, behavior: 'smooth' });
  }
  markAsCompleted(content: any) {
    this.modal.open(content, { centered: true, size: 'md' })
  }
  open(content3: any) {
    this.modal.open(content3, { centered: true, size: 'md' }).result
  }
  openConflict(content2: any) {
    this.modal.open(content2, { centered: true, size: 'md' })
  }
  goToChat() {
    this.router.navigateByUrl(`chat/${this.id}`)
  }
  confirmResolution() {
    this.modal.dismissAll()
    Swal.fire({
      title: 'Conflict Resolution',
      text: 'Management has been notified of your conflict and will be with you shortly',
      icon: 'success',
      confirmButtonText: 'Done'
    })
  }

  TimeSet() {
    if (this.minutes < 1) {
      return;
    }
    const data = {
      order_id: this.id,
      delay: this.minutes
    }
    this.service.setOrderDelay(data).subscribe({
      next: (res) => {
        this.modal.dismissAll()
        Swal.fire({
          title: 'Time Set',
          text: 'Wait time set, you can use the chat customer button to chat with customer for concerns or clarification',
          icon: 'success',
          confirmButtonText: 'Done',
        });
      }, error: (err) => {
        Swal.fire({
          title: "Failed!",
          text: err.error.message,
          icon: "error"
        });
      }, complete: () => {
        this.getOrderDetails()
      }
    })

  }

  settime(content2: any) {
    this.modal.dismissAll()
    this.modal.open(content2, { centered: true, size: 'md' }).result
  }
  minus() {
    if (this.minutes >= 0.1) {
      this.minutes--
    }
  }
  plus() {
    this.minutes++
  }

  cancelItem(id: any) {
    this.isCancellingItem = true;
    const data = {
      order_id: this.id,
      order_item_id: id,
      return_type: "all",
      return_reason: "too much money"
    }

    Swal.fire({
      // title: "State didmiss reason",
      text: "Why do you want to remove this?",
      input: "text",
      // inputAttributes: {
      //   autocapitalize: "off"
      // },
      showCancelButton: true,
      confirmButtonText: "Remove",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {
        try {
          data.return_reason = login
        } catch (error: any) {
          Swal.fire('', error, 'error')
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.service.returnItem(data).subscribe({
          next: (res) => {
            Swal.fire({
              title: "Deleted!",
              text: "Item has been removed.",
              icon: "success"
            });
          }, error: (err) => {
            Swal.fire({
              title: "Failed!",
              text: err.error.message,
              icon: "error"
            });
          },
          complete: () => {
            this.getOrderDetails();
            this.isCancellingItem = false;
          }
        })
      } else {
        this.isCancellingItem = false;
      }
    });
  }

  markOrder(status: any) {
    this.isMarkingDelivered = true;
    const data = {
      order_id: this.id,
      status: status
    }
    this.service.markOrder(data).subscribe({
      next: (res) => {
        this.modal.dismissAll();
        Swal.fire({
          title: "Delivered!",
          text: "Order has been delivered.",
          icon: "success"
        });
      }, error: (err) => {
        Swal.fire({
          title: "Failed!",
          text: err.error.message,
          icon: "error"
        });
      }, complete: () => {
        this.getOrderDetails();
        this.isMarkingDelivered = false;
      }
    })
  }

  confirmPayment() {
    this.isProcessingPayment = true;
    // Simulate API call delay
    setTimeout(() => {
      this.router.navigateByUrl(`orders/${this.id}/payment_method`);
      this.isProcessingPayment = false;
    }, 800);
  }
  addItem() {
    this.router.navigateByUrl(`orders/${this.id}/categories`)
  }

  getTotalReceived(): number {
    return this.orderDetails?.transactionLog?.reduce((sum: number, transaction: any) => {
      return sum + (parseFloat(transaction.amount) || 0);
    }, 0) || 0;
  }

  getRemainingAmount(): number {
    const totalAmount = this.orderDetails?.total_amount || 0;
    const totalReceived = this.getTotalReceived();
    return totalAmount - totalReceived;
  }

  viewAccountDetails(account: any) {
    if (account.payment_status !== 'paid' && !account.is_expired) {
      this.selectedAccount = account;
      this.modal.open(this.accountDetailsModal, {
        centered: true,
        size: 'md'
      });
    }
  }

  // Add this method to sort bank accounts
  getSortedBankAccounts() {
    if (!this.orderDetails?.bank_accounts) return [];

    return [...this.orderDetails.bank_accounts].sort((a, b) => {
      // Priority order: Active (unpaid) -> Paid -> Expired
      if (a.payment_status !== 'paid' && !a.is_expired) return -1;
      if (b.payment_status !== 'paid' && !b.is_expired) return 1;
      if (a.payment_status === 'paid' && b.payment_status !== 'paid') return 1;
      if (a.payment_status !== 'paid' && b.payment_status === 'paid') return -1;
      return 0;
    });
  }

  closeOrder() {
    Swal.fire({
      title: 'Close Order?',
      html: `
        <div class="text-danger mb-3">
          <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
          <p class="mb-0">This action cannot be undone!</p>
        </div>
        <p>Are you sure you want to close this order?</p>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Close Order',
      confirmButtonColor: '#dc3545',
      cancelButtonText: 'No, Cancel',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return this.service.closeOrder(this.id!).toPromise()
          .catch(error => {
            Swal.showValidationMessage(
              `Request failed: ${error.error.message || 'Something went wrong'}`
            );
          });
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Order Closed!',
          text: 'The order has been successfully closed.',
          icon: 'success'
        }).then(() => {
          this.router.navigateByUrl(`/`);
        });
      }
    });
  }

  // Add this computed property
  get isOrderActive(): boolean {
    return this.orderDetails?.status !== 'completed'
           && this.orderDetails?.status !== 'closed' ;

  }

}
